var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.596,
    height: 14.596,
    viewBox: "0 0 14.596 14.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-search",
    "data-name": "Icon material-search",
    d: "M14.931,13.68h-.659l-.234-.225a5.433,5.433,0,1,0-.584.584l.225.234v.659L17.852,19.1,19.1,17.852Zm-5.007,0A3.755,3.755,0,1,1,13.68,9.924,3.75,3.75,0,0,1,9.924,13.68Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#122866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d5cff8ffcf0dbcb0f4d5c55b290c2e6f.svg";
export { ForwardRef as ReactComponent };